/* 
Author:Lamiaa Moustafa
Desc: All Buttons styles js
*/

import styled from "styled-components";

export const Button = styled.button`
  background-color: var(--orange);
  background-color: ${(props) => props.backgroundColor};
  width: 125px;
  min-width: 115px;
  min-height: 50px;
  border: 1px solid var(--white);
  border-radius: 30px;
  color: var(--white);
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1em;
  letter-spacing: 2px;
  font-weight: var(--regularFont);
  margin: 20px;
  cursor: pointer;
  z-index: 99;
  &:hover {
    background-color: var(--white);
    transform: scale(0.95);
    color: var(--orange);
    border: 1px solid var(--orange);
    transition: all 0.5s ease-in-out;
  }
`;

export const ButtonDiv = styled.div`
  height: 20vh;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: var(--fontFamily);

  .linkStyle {
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 400;
    color: var(--white);
    margin-top: 20px;
    cursor: pointer;
    z-index: 99;
    @media (max-width: 768px) {
      text-align: center;
    }
    &:hover {
      color: var(--orange);
      text-decoration: underline;
      font-style: italic;
    }
  }
`;
